<template>
  <vxe-table border resizable show-overflow keep-source :data="tableData">
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) of tableColumn"
      :key="index"
      :field="item.field"
      :title="item.title"
      :edit-render="item.itemRender"
      :minWidth="item.width"
    >
      <template v-slot="{ row }">
        <template v-if="item.field === 'billStatus'">
          {{ translateBillStatus(row.billStatus) }}
        </template>
        <template v-else>{{ row[item.field] }}</template>
      </template>
    </vxe-table-column>
  </vxe-table>
</template>

<script>
  export default {
    name: 'ApprovalRecordTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '监管单状态',
            field: 'billStatus',
            width: 150,
          },
          {
            title: '跳转时间',
            field: 'operateDate',
            width: 190,
          },
          {
            title: '审批时间',
            field: 'approvalDate',
            width: 190,
          },
          {
            title: '审批人',
            field: 'approvalPersonName',
            width: 190,
          },
          {
            title: '部门',
            field: 'approvalDepartmentName',
            width: 190,
          },
        ],
        tableData: [],
        supervisionBillStatusList: [], // 监管单状态
      };
    },
    mounted() {
      this.supervisionBillStatusList = this.dictListMap.SuperviseBillStatusType;
    },
    methods: {
      // 翻译监管单状态
      translateBillStatus(val) {
        return this.supervisionBillStatusList.find((item) => item.value == parseInt(val))?.label;
      },
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
